<template>
    <div class="bootstrap-wrapper main">

        <div class="container ">
            <div class="row d-flex justify-content-center mt-lg-5 mt-0 ">
                <div class="col-lg-10 row body p-0">
                    <div class="col-lg-6 imgLogin rounded-left">

                        <img class="img-fluid d-md-block d-lg-none w-100" src="../../assets/img/login/Login_Photo_mobile.png" v-bind:alt="$t('language.posadasCorporate.login.iLogin')">

                    </div>
                    <div class="col-lg-6 pt-3 px-lg-5 rounded-right">
                        <div class="col-12 ">
                            <!-- Images -->
                            <div class="d-flex justify-content-between pb-5 pt-4">
                                <img class="customLogin-logo" src="../../assets/img/posadas-corporate.svg" v-bind:alt="$t('language.posadasCorporate.posadasCorporate')">
                                <section class="d-flex align-items-center">
                                    <Languages />
                                </section>
                            </div>
                            <!-- From -->
                            <form @submit.prevent="handleSubmit">
                                <div class="">
                                <p class="subtitle">{{ $t('language.posadasCorporate.login.init') }}</p>
                                </div>
                                <div class="form-element">
                                  <label for="groupId">{{ $t('language.posadasCorporate.login.groupId') }}*</label>
                                  <div class="">
                                  <input
                                    type="text"
                                    @keydown.space.prevent
                                    v-model="user.groupId"
                                    id="groupId"
                                    name="groupId"
                                    class="form-control idInput"
                                    :class="{ 'is-invalid': submitted  && !$v.user.groupId.required || !$v.user.groupId.maxLength}"            
                                    :disabled="!!user.clientId" 
                                  />
                                  <div v-if="submitted && !$v.user.groupId.required" class="invalid-feedback">{{ $t('language.posadasCorporate.login.groupIncorrect') }}</div>
                                  <span class="invalid-feedback" v-if="!validateGroupIdFormat()">
                                            {{$t('language.posadasCorporate.login.invalidGroupIdFormat')}} 
                                  </span>
                                  <span class="invalid-feedback" v-if="!$v.user.groupId.maxLength">
                                            {{$t('language.posadasCorporate.login.mayor7')}} {{$v.user.groupId.$params.maxLength.max}} {{$t('language.posadasCorporate.login.mayor2')}}
                                        </span>
                                </div>
                                </div>
                                <div class="form-element" >
                                    <label for="clientId" :class="{ 'disabled': !!user.groupId }">{{ $t('language.posadasCorporate.login.clientId') }}*</label>
                                    <div class="">
                                        <input  type="text" @keydown.space.prevent v-model="user.clientId" id="clientId" name="clientId" class="form-control idInput" :class="{ 'is-invalid': submitted && $v.user.clientId.$error || !$v.user.clientId.maxLength }  " :disabled="!!user.groupId" >
                                        <div v-if="submitted && !$v.user.clientId.required" class="invalid-feedback">{{ $t('language.posadasCorporate.login.clientIncorrect') }}</div>
                                        <span class="invalid-feedback" v-if="!$v.user.clientId.maxLength">
                                            {{$t('language.posadasCorporate.login.mayor1')}} {{$v.user.clientId.$params.maxLength.max}} {{$t('language.posadasCorporate.login.mayor2')}}
                                        </span>
                                    </div>
                                    <div class="">
                                          <input v-model="check1" type="checkbox" name="saveClient" id="saveClient">
                                    <label class="checkBoxText">{{ $t('language.posadasCorporate.login.rememberClient') }} </label>
                                    </div>
                                </div>
                                <div class="form-element ">
                                    <label for="userName">{{ $t('language.posadasCorporate.login.user') }}*</label>
                                    <div class="">
                                        <input type="text" @keydown.space.prevent v-model="user.userName" id="userName" name="userName" class="form-control minuscula" :class="{ 'is-invalid': submitted && $v.user.userName.$error || !$v.user.userName.maxLength }" :disabled="!!user.groupId">
                                        <div v-if="submitted && !$v.user.userName.required" class="invalid-feedback">{{ $t('language.posadasCorporate.login.nameIncorrect') }}</div>
                                        <span class="invalid-feedback" v-if="!$v.user.userName.maxLength">
                                            {{$t('language.posadasCorporate.login.mayor3')}} {{$v.user.userName.$params.maxLength.max}} {{$t('language.posadasCorporate.login.mayor2')}}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-element">
                                    <label for="password">{{ $t('language.posadasCorporate.login.pass') }}*</label>
                                    <div class="Pos-r">
                                        <input  :type="passwordFieldType"  v-model="user.password" id="password" name="password" class="form-control password" :class="{ 'is-invalid': submitted && $v.user.password.$error || !$v.user.password.maxLength }" :disabled="!!user.groupId" />
                                        <p class="__eyeIcon buttonEye" :class="[btnValidator, openEye]"  @click="switchVisibility"></p>
                                    <div v-if="submitted && !$v.user.password.required" class="invalid-feedback">{{ $t('language.posadasCorporate.login.passIncorrect') }}</div>
                                    <span class="invalid-feedback" v-if="!$v.user.password.maxLength">
                                            {{$t('language.posadasCorporate.login.mayor4')}} {{$v.user.password.$params.maxLength.max}} {{$t('language.posadasCorporate.login.mayor2')}}
                                        </span>
                                    </div>
                                    <div>


                                    <input v-model="check2" type="checkbox" name="saveUser" id="saveUser">
                                    <label class="checkBoxText">{{ $t('language.posadasCorporate.login.rup') }} </label>                                     </div>
                                </div>
                                    <Loader v-if="enableLoader"/>
                                <div class="form-element pt-4">
                                    <button :disabled="isDisabled" >{{ $t('language.posadasCorporate.login.start') }}</button>
                                </div>
                            </form>

                        <div class="pt-4">
                            <p><router-link class="colorBlue enlaceLogin" to="/recuperar-contrasena">{{ $t('language.posadasCorporate.login.q1') }}</router-link></p>
                            <p><router-link class="colorBlue enlaceLogin" to="/problemas-para-inicar">{{ $t('language.posadasCorporate.login.q2') }}</router-link></p>
                        </div>
                        <div class="pt-4 pb-md-5 pb-4">
                          <a class="contactoLogin" href="tel:44 3298 2253">
                            <i class="demo-icon icon-telephone"> </i>
                            México: 44 3298 2253
                          </a>
                          <a class="contactoLogin" href="tel:1 800 3437 821">
                            <i class="demo-icon icon-telephone"> </i>
                            {{$t('language.posadasCorporate.login.usa')}}: 1 800 3437 821
                          </a>
                          <a class="contactoLogin" @click="redirectWhatsApp" onclick="return false;" href="#">
                            <i class="demo-icon icon-whatsapp"> </i>
                            44 3137 8728
                          </a>
                          <a class="contactoLogin" @click="chatting" href="">
                            <i class="demo-icon icon-chat"> </i>
                            {{$t('language.posadasCorporate.login.chat')}}
                          </a><br><br>
                          <a class="nota" v-on:click="redirecPoliticas" onclick="return false;" href="#">{{ $t('language.posadasCorporate.login.p1') }}</a>
                          <span> · </span>
                          <a class="nota" v-on:click="redirecTerminos" onclick="return false;" href="#">{{ $t('language.posadasCorporate.login.p2') }}</a><br>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <!--  MODAL USUARIO DESHABILITADO -->
                <modal v-show="banModalUnableUser" @close="closeModalUnableUser" maxWidth="max-w-500">
          <template slot="header">
            <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t("language.posadasCorporate.login.unableTitle")}}</b>
          </template>
          <template slot="body">
            
              
            
            <p class="Ta-left">
              
              {{$t("language.posadasCorporate.login.unableBody")}} 
            </p>
          </template>
          <template slot="footer">
            <button type="button" class="button btn-primary" @click="closeModalUnableUser"
              aria-label="Close modal">
              {{$t("language.posadasCorporate.login.entendido")}}
            </button>
          </template>
        </modal>
        <!--  MODAL USUARIO DESHABILITADO -->

        <modal v-show="banModal" @close="closeModal" maxWidth="max-w-500">
          <template slot="header">
            <b class="danger"> <i class="icon-close-rounded-fill Fw-bolder"></i> {{$t("language.posadasCorporate.login.WSError")}}</b>
          </template>
          <template slot="body">
            <p class="Ta-left">
              {{$t("language.posadasCorporate.login.textoModal1")}}
            </p>
            <p class="Ta-left">
              
              {{$t("language.posadasCorporate.login.textoModal2")}} <a href='https://api.whatsapp.com/send?phone=5214431378728&text=Hola,%C2%BFMe%20pueden%20ayudar?'>{{$t("language.posadasCorporate.login.textoModal3")}}</a> {{$t("language.posadasCorporate.login.textoModal4")}} <a href='tel:4432982253'>{{$t("language.posadasCorporate.login.textoModal5")}}</a>.
            </p>
          </template>
          <template slot="footer">
            <button type="button" class="button btn-primary" @click="closeModal"
              aria-label="Close modal">
              {{$t("language.posadasCorporate.login.entendido")}}
            </button>
          </template>
        </modal>

        <modal v-show="banModalGroup" @close="closeModalGroup" maxWidth="max-w-500">
          <template slot="header">
            <b class="danger"> <i class="icon-close-rounded-fill Fw-bolder"></i> {{$t("language.posadasCorporate.login.WSError")}}</b>
          </template>
          <template slot="body">
            <p class="Ta-left">
              {{$t("language.posadasCorporate.login.textoModalGrupo")}}
            </p>
            <p class="Ta-left">
              
              {{$t("language.posadasCorporate.login.textoModal2")}} <a href='https://api.whatsapp.com/send?phone=5214431378728&text=Hola,%C2%BFMe%20pueden%20ayudar?'>{{$t("language.posadasCorporate.login.textoModal3")}}</a> {{$t("language.posadasCorporate.login.textoModal4")}} <a href='tel:4432982253'>{{$t("language.posadasCorporate.login.textoModal5")}}</a>.
            </p>
          </template>
          <template slot="footer">
            <button type="button" class="button btn-primary" @click="closeModalGroup"
              aria-label="Close modal">
              {{$t("language.posadasCorporate.login.entendido")}}
            </button>
          </template>
        </modal>

        <modal v-show="banModalGroupDates" @close="closeModalGroupDates" maxWidth="max-w-500">
          <template slot="header">
            <b class="danger"> <i class="icon-close-rounded-fill Fw-bolder"></i> {{$t("language.posadasCorporate.login.WSError")}}</b>
          </template>
          <template slot="body">
            <p class="Ta-left">
              {{$t("language.posadasCorporate.login.textoModalGrupoDates")}}
            </p>
            <p class="Ta-left">
              
              {{$t("language.posadasCorporate.login.textoModal2")}} <a href='https://api.whatsapp.com/send?phone=5214431378728&text=Hola,%C2%BFMe%20pueden%20ayudar?'>{{$t("language.posadasCorporate.login.textoModal3")}}</a> {{$t("language.posadasCorporate.login.textoModal4")}} <a href='tel:4432982253'>{{$t("language.posadasCorporate.login.textoModal5")}}</a>.
            </p>
          </template>
          <template slot="footer">
            <button type="button" class="button btn-primary" @click="closeModalGroupDates"
              aria-label="Close modal">
              {{$t("language.posadasCorporate.login.entendido")}}
            </button>
          </template>
        </modal>
    </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import * as GlobalFunctions from '../../utils/GlobalFunctions';
import Languages from '../languages/Languages';
import { required, maxLength,requiredIf } from "vuelidate/lib/validators";
import axios from 'axios';
import i18n from '../../plugins/i18n';
import SecureLS from 'secure-ls';
import Loader from '../loader/Loader';
import Modal from '../addons/Modal.vue';
import * as GlobalServices from '../../utils/GlobalServices';
import moment from 'moment'
const STORAGE_KEY = {
    Token: 'Token',
    ClientId: 'ClientId',
    User: 'User',
    Password: 'Password',
    Language: 'Language'
};

  export default {
    name: 'Login',
    components: {
        Languages,
        Loader,
        Modal
    },
    data: () => {
        return {
          groupIdUrl: false,
          banModalUnableUser: false,
          groupValue: false,
          check1:false,
          check2: false,
          dataUser: {
            clientID: '',
            groupId: '',
            user: '',
            pass: '',
            check1: false,
            check2: false
          },
          ls: new SecureLS({encodingType: 'aes'}),
            validRegex: /^[a-zA-Z\\d\\@\\ñ\\*\\&\\_\\-\\d*\.?\d*]*$/, // Allow "ñ"
            invalidRegex: /([a-zA-Z\\d\\@\\*\\&\\_\\-])\\1\\1/,
            enableLoader: false,
            modalMessage: '',
            password: '',
            passwordFieldType: 'password',
            openEye: '__eyeIcon',
            closeEye: '__closeEyeIcon',
            btnState: '',
            user: {
                    clientId: "",
                    groupId: "",
                    userName: "",
                    password: "",
                },
            submitted: false,
        error500: false,
        valClientId: '',
        valGroupId: '',
        valUserName: '',
        valPass: '',
           password: {
          required,
          maxLength: maxLength(20)
        },
        banModalGroup: false,
        banModalGroupDates: false,
        banModal: false
        }
    },
    validations: {
        user: {
            clientId: { required: requiredIf(function () {
          return !this.user.groupId; // Required only if groupId is empty
        }), maxLength: maxLength(50) },
            groupId: { required:requiredIf(function () {
          return !this.user.clientId; // Required only if clientId is empty
        }) , maxLength: maxLength(50),
        /*format: value => /^[A-Z0-9]{6}@[A-Z0-9]{3}$/i.test(value)*/
      },
            userName: {required: requiredIf(function () {
          return !this.user.groupId; // Required only if groupId is empty
        }),  maxLength: maxLength(50) },
            password: {required: requiredIf(function () {
          return !this.user.groupId; // Required only if groupId is empty
        }),  maxLength: maxLength(20) },
        }
    },
    methods: {
      validateGroupIdFormat() {
      if(this.user.groupId === "")
      {
        
        return true;
      }
     
      const regex = /^[A-Z0-9]{6}@[A-Z0-9]{3}$/i
      var ed = regex.test(this.user.groupId);
      return ed;
    },
      getURLParameters() {
        
        // obtain actual url
      const currentURL = window.location.href;
      
      // Parse la URL to obtain params
      const urlSearchParams = new URLSearchParams(new URL(currentURL).search);

      // get 'groupId' parama
      const groupId = urlSearchParams.get('groupId');
      
      
      if (groupId) {
        this.groupIdUrl = true;
        this.user.groupId = groupId;
        this.handleSubmit();
      }
    },
      sesionClose(){
        console.log(this.banModal);
        if(this.banModal != true){
        GlobalFunctions.localStorageClean();
        window.location.reload();
        }
      },
      saveGroupInfo(payload){
        const { hotelCode, groupCode, currencyCode, checkIn, checkOut, roomCodes } = payload;
        this.$store.commit("setHotelCode", {hotelCode});
        this.$store.commit("setGroupCode", {groupCode});
        this.$store.commit("setCurrencyCode", {currencyCode});
        this.$store.commit("setCheckIn", {checkIn});
        this.$store.commit("setCheckOut", {checkOut});
        this.$store.commit("setRoomCodes", {roomCodes});
      },
      clearForm(){
     
      this.user.userName = "";
      this.user.clientId = "";
      this.user.password = "";

      },
      settearEnv(){
        if(process.env.VUE_APP_HOSTCORPORATEAPI == "https://www.corpo-rate.com/") {
          this.$store.commit("changeJsonProd", true);
          window.localStorage.setItem('isP', 'true');
        } else {
          this.$store.commit("changeJsonProd", false);
          window.localStorage.setItem('isP', 'false');
        }
      },
      encryptPass(passw){
        var secretKey = 'C0rp0r4t3Secret';
        var encrypted = CryptoJS.AES.encrypt(passw, secretKey);
        return encrypted.toString();
      },
      closeModalUnableUser() {
          this.banModalUnableUser = false
      },
      closeModalGroup() {
          this.banModalGroup = false
          GlobalFunctions.localStorageClean();
          //this.clearForm();
          if(!this.groupIdUrl){
            window.location.reload();
            this.clearForm()
          }
          else {
            this.$router.push({ name: 'Login'});
            this.clearForm()
           
          }

      },
      closeModalGroupDates() {
          this.closeModalGroupDates = false;
          GlobalFunctions.localStorageClean();
          //this.clearForm();
          if(!this.groupIdUrl){
            window.location.reload();
            this.clearForm()
          }
          else {
            this.$router.push({ name: 'Login'});
            this.clearForm()
           
          }
      },
      closeModal(){
        this.banModal = false;
      },
      redirecTerminos(){
        this.$router.push({ name: 'TerminosCondiciones'})
      },
      redirecPoliticas() {
        (this.ls.get('Language').data=='es'?window.open(process.env.VUE_APP_POLICIES, '_blank'):window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
      },
      redirectMaintenance(){
      console.log(process.env.VUE_APP_IS_MAINTENANCE);
        if(process.env.VUE_APP_IS_MAINTENANCE==="true"){
          this.$router.push({ name: 'Maintenance'})
        }
      
      },
      validaDataUser(){
        if (this.ls.get('dUaStEaR') === '') {
          this.ls.set('dUaStEaR', this.dataUser);
        } else{
          this.dataUser = this.ls.get('dUaStEaR');
          this.user.clientId = this.dataUser.clientID;
          this.user.userName = this.dataUser.user.toLowerCase();
          this.user.password = this.dataUser.pass;
          this.check1 = this.dataUser.check1;
          this.check2 = this.dataUser.check2;
        }
      
      },
      guardaDataUser(){
        if (this.check1) {
          this.dataUser.clientID = this.user.clientId.toUpperCase();
          this.dataUser.check1 = this.check1;
        }

        if (this.check2) {
          this.dataUser.user = this.user.userName.toLowerCase();
          this.dataUser.pass = this.user.password;
          this.dataUser.check2 = this.check2;
        }

        if (!this.check1) {
          this.dataUser.clientID = '';
          this.dataUser.check1 = false;
        }

        if (!this.check2) {
          this.dataUser.user = '';
          this.dataUser.pass = '';
          this.dataUser.check2 = false;
        }

        this.ls.set('dUaStEaR', this.dataUser);


      },
chatting() {
          var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language');
          if(this.language.data == 'es') {
            window.open(process.env.VUE_APP_CHATTINGES, '_blank');
          } else {
            window.open(process.env.VUE_APP_CHATTINGEN, '_blank');
          }
      },
      
      redirectWhatsApp() {
        window.open(process.env.VUE_APP_WHATSAPP, '_blank');
      },
        perfection2() {
         var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language');
          if(this.language.data == 'es') {

            window.open(process.env.VUE_APP_CONDITIONS, '_blank');
          } else {
            window.open(process.env.VUE_APP_CONDITIONSEN, '_blank');

          }
      },

        show () {
   this.$modal.show('hello-world')

  },
  hide () {
    this.$modal.hide('hello-world');
  },

        handleSubmit(e) {
         
          this.submitted = true;
          var ls = new SecureLS({encodingType: 'aes'});
          if(this.user.groupId){
            if (!this.validateGroupIdFormat()) {
              return; // Stop form submission if the format is invalid
            }
            this.groupValue = true;
          }
          else{
            this.groupValue = false;
          }
          // stop here if form is invalid
          this.$v.$touch();
          if (this.$v.$invalid) {
            return;
          } 
          if(this.groupValue){
            
           
            this.user.clientId = process.env.VUE_APP_USER_ID;
            this.user.userName = process.env.VUE_APP_USER_USERLOGIN;
            this.user.password = process.env.VUE_APP_PASSWORD;
            this.check1 = this.dataUser.check1;
            this.check2 = this.dataUser.check2;
          }
          const formData = {
              clientId: this.user.clientId,
              username: this.user.userName.toLowerCase(),
              password: this.user.password
          }  
     var capitalized = this.user.clientId.toUpperCase();
     ls.set('ClientId', {data: capitalized}); // set key1
     
    if ( document.getElementById("saveClient").checked) {
                    var AESEncryption1 = ls.get('ClientId')
            } 
            if (document.getElementById("saveUser").checked) {
                    ls.set('User', {data: this.user.userName.toLowerCase()}); // set key1
                    var AESEncryption2 = ls.get('User')
                    ls.set('Password', {data: this.user.password}); // set key1
                    var AESEncryption3 = ls.get('Password')
            }
            this.loggedIn(formData)
        },
         loggedIn(a) {
    this.enableLoader = true
    var res = a.clientId.toUpperCase();
    var ls = new SecureLS({encodingType: 'aes'});
    
    ls.set('userIdForReservationRequest', {data: a.username})
    axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_LOGIN, {
    username: a.username,
    password: btoa(this.encryptPass(a.password.split('').reverse('').join(''))),
    clientId: res
  })
  .then(res => {
   
    this.enableLoader = false
         var resObject=JSON.parse(JSON.stringify(res));
         
        var profileObject = JSON.parse(resObject.headers.profile);
                    var ls = new SecureLS({encodingType: 'aes'});
         ls.set('Profile', {data: profileObject}); // set key1
  ls.set('clientIdAdd', {data: this.user.clientId})
     var  token = resObject.headers.authorization
      var realToken = token.substr(6);
      if(this.groupValue){
        
        var result = GlobalFunctions.separateText(this.user.groupId.toUpperCase());
        
            var data = {
              groupCode: result.beforeAt,
              hotelCode: result.afterAt
            };
            GlobalServices._searchgroupinfo(realToken, this.ls.get('Language').data,data).then(response => {
              var resObject=JSON.parse(JSON.stringify(response));
              
            if (response.status === 200) {
              var date1 = moment(response.data.checkOut)
              var date2 = moment()
              if(date1 <  date2){
                this.banModalGroupDates = true;
                console.log("Error grupo con fechas caducadas" );
                return;
              }
              var payload = {
                groupCode: data.groupCode,
                hotelCode: data.hotelCode,
                currencyCode: response.data.currencyCode,
                roomCodes: response.data.roomCodes,
                checkIn: response.data.checkIn,
                checkOut: response.data.checkOut
              }
              var ls = new SecureLS({encodingType: 'aes'});
                    ls.set('InfoGrupo', {data: payload});
              this.saveGroupInfo(payload);
              if ( resObject.status == 200 || resObject.status == 201) {
                
                if(profileObject.activeUser) {
                    var ls = new SecureLS({encodingType: 'aes'});
                    ls.set('Token', {data: realToken}); // set key1
                    var AESEncryption4 = ls.get('Token')
                    this.modalMessage = i18n.t("language.posadasCorporate.login.WSMessage")
                    this.guardaDataUser();

                    this.$router.push({ name: 'Reservaciones'})
                    
                    } else {
                      this.banModalUnableUser = true     
                    }
                } else {
                      this.enableLoader = false
                }
              }
            }).catch(error2 => {
              if (error2.status === 401) {
                //token caduco
                console.log("error token");
              }
              let errorObject=JSON.parse(JSON.stringify(error2));
              if(errorObject.message == 'Network Error' || ( error2.status < 600 && error2.status > 403 ) || ( error2.status < 399 && error2.status > 299  ) ||  error2.status < 200   ) {
                
                this.banModalGroup = true;

                console.log("Error grupo no encontrado" );
              } 
            });
        }
        else{
          if ( resObject.status == 200 || resObject.status == 201) {
                if(profileObject.activeUser) {
                    var ls = new SecureLS({encodingType: 'aes'});
                    ls.set('Token', {data: realToken}); // set key1
                    var AESEncryption4 = ls.get('Token')
                    this.modalMessage = i18n.t("language.posadasCorporate.login.WSMessage")
                    this.guardaDataUser();
                    this.$router.push({ name: 'Reservaciones'})
                    
                    } else {
                      this.banModalUnableUser = true     
                    }
                } else {
                      this.enableLoader = false
                }
        }
      }
   
           )
      .catch(error=>{
        console.log(error);
            this.enableLoader = false
        let errorObject=JSON.parse(JSON.stringify(error));
if (errorObject.message == 'Request failed with status code 401' ) {
     this.error500 = true
              this.banModal = true;
} else {
     this.error500 = false
}

if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error2" });
}

})
         },
        switchVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            this.openEye = this.openEye === '__eyeIcon' ? '__closeEyeIcon' : '__eyeIcon'
        },

      },
      
    created() {
      this.settearEnv();
      this.validaDataUser();
      
      this.valClientId = this.ls.get('ClientId')
      this.valPass = this.ls.get('Password')
      this.valUserName = this.ls.get('User')
      if (this.valClientId != '') {
      this.user.clientId = this.valClientId.data

      } else {

      }
      if (this.valUserName != '') {
      this.user.userName = this.valUserName.data.toLowerCase()
      } else {

      }
      if (this.valPass != '') {
      this.user.password = this.valPass.data
      } else {

      }
    },
    mounted(){
      this.getURLParameters();
    },
    beforeMount() {
      
      this.redirectMaintenance();
        GlobalFunctions.tokenExistValidate().then(response => {
            if(response){
              this.$router.push({ name: "Reservaciones" });
            }
        });
    },
    watch: {
        unlockLanguages() {
          if(this.unlockLanguages) {
                   this.$store.commit('blockLanguages', {turn: false})
          }
        }
    },
    computed: {

      unlockLanguages() {
                   this.$store.commit('blockLanguages', {turn: false})

            return this.$store.getters.gettingLangBlock
      },
        doubleCounter() {
                return this.$store.getters.doubleCounter
        },
        isDisabled() {
            if(this.user.groupId.length > 1 && this.validateGroupIdFormat())
            {
              return false;
            }
            else{
            if (this.user.clientId.length > 1 && this.user.userName.length > 1 && this.user.password.length > 1  
            && this.$v.user.userName.maxLength && this.$v.user.clientId.maxLength && this.validRegex.test(this.user.clientId) && this.validRegex.test(this.user.userName.toLowerCase()) )   { 
                return false;
            } else {
                    return true;
            }
          }
        },
        btnValidator() {
            if(this.user.groupId === "")
            {
              if( this.user.password.length === 0 ){
                  return 'normal'
              } else if(this.user.password.length > 0) {
                  return 'activo'
              } else {
                  return 'error'
              }
          }
        },
    },
  };

</script>

<style lang="scss" scoped>
  @import '../../assets/scss/config.scss';
.minuscula {
  text-transform: lowercase;
}
  .Pos-r {
    position: relative;
  }

  .buttonEye {
    height: 100%;
    width: 10%;
    position: absolute;
    right: 0;
    top: 0;
}
.colorBlue {
    color: $colorBase2;
  }

  .contactoLogin {
    font-size: 12px;
    font-weight: 300;
    color: #005a83;
    padding-right: 5px;

    .demo-icon {
      font-size: 20px;
    }
    .demo-icon:before {
      margin-left: 0px;
    }
  }

  /* Large devices (laptops/desktops, 1024px and up) */
  @media only screen and (min-width: 992px) {
    .imgLogin {
      background-image: url(../../assets/img/login/Login_Photo.png);
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

  @media (max-width: 991px) {
    .imgLogin {
      padding: 0 !important;
    }
  }

  .imgLogin {
    font-size: 0;
    line-height: 0;
  }


  .normal::after {
    color: #757575;
  }

  .activo::after {
    color: $colorBase2;
  }

  .error::after {
    color: #9d1b24;
  }


  .enlaceLogin {
    font-weight: 500;
    display: inline-block;
}
.notas {
    font-size: $font-size-small;
    color: $grayShadeDark !important;
}
.redirec {
    color: red;
    font-size: 50px;
}

  .form-control {
    line-height: 1rem !important;
  }

</style>
